(function (root) {
  'use strict';
  if (root.JEGiftCart) return;
  root.JEGiftCart = Object.freeze({ tokenProperty: '_Gift submission', payloadProperty: '_Gift payload',
    create(config = {}) {
      if (!root.JEBirthflowerCart?.create) throw new Error('The cart tools did not load. Refresh the page to try again.');
      return root.JEBirthflowerCart.create({ ...config, kind: 'gift' });
    }
  });
})(typeof globalThis !== 'undefined' ? globalThis : this);
